<ng-container *transloco="let t">
  <p-dialog
    #dialog
    [visible]="display$ | async"
    (visibleChange)="onVisibleChange($event)"
    appendTo="body"
    [modal]="true"
    [dismissableMask]="false"
    [draggable]="false"
    [blockScroll]="true"
    styleClass="grid-columns-dialog"
  >
    <p-header><i class="fad fa-columns mr-1"></i> {{ t('core.components.grid.columns.columns') }}</p-header>

    <div>
      <p-pickList
        #pickList
        styleClass="grid-columns-dialog-picklist"
        [dragdrop]="true"
        [responsive]="true"
        filterBy="header"
        [trackBy]="trackBy"
        [sourceStyle]="picklistHeight$ | async"
        [source]="availableColumns$ | async"
        [showSourceFilter]="(windowService.mobile$ | async) === false"
        [showSourceControls]="false"
        sourceFilterPlaceholder="{{ t('core.components.grid.columns.search_columns') }}"
        sourceHeader="{{ t('core.components.grid.columns.available_columns') }}"
        [targetStyle]="picklistHeight$ | async"
        [target]="selectedColumns$ | async"
        [showTargetFilter]="(windowService.mobile$ | async) === false"
        targetFilterPlaceholder="{{ t('core.components.grid.columns.search_columns') }}"
        targetHeader="{{ t('core.components.grid.columns.selected_columns') }}"
      >
        <ng-template let-column pTemplate="item">
          <div>
            <div>
              {{ column.header | removeNewline }}
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="emptymessagesource">
          <z-no-results
            #noColumnsSource
            type="picklist-no-columns"
            iconLayer1="fad fa-triangle-exclamation"
            [showIconLayer2]="false"
            [animate]="false"
            parentSelector=".p-picklist-source .p-picklist-empty-message"
            title="{{ t('core.components.grid.columns.no_more_columns.title') }}"
            description="{{ t('core.components.grid.columns.no_more_columns.description') }}"
          ></z-no-results>
        </ng-template>

        <ng-template pTemplate="emptymessagetarget">
          <z-no-results
            #noColumnsTarget
            type="picklist-no-columns"
            iconLayer1="fad fa-triangle-exclamation"
            [showIconLayer2]="false"
            [animate]="false"
            parentSelector=".p-picklist-target .p-picklist-empty-message"
            title="{{ t('core.components.grid.columns.must_select_at_least_one_column.title') }}"
            description="{{ t('core.components.grid.columns.must_select_at_least_one_column.description') }}"
          ></z-no-results>
        </ng-template>

        <ng-template pTemplate="emptyfiltermessagesource">
          <z-no-results
            #noResultsSource
            type="picklist-empty"
            iconLayer1="fa-thin fa-magnifying-glass fa-stack-1x"
            iconLayer2="fa fa-exclamation fa-flash fa-stack-2x"
            parentSelector=".p-picklist-source .p-picklist-empty-message"
            title="{{ t('core.components.grid.columns.no_results.title') }}"
            description="{{ t('core.components.grid.columns.no_results.description') }}"
          ></z-no-results>
        </ng-template>

        <ng-template pTemplate="emptyfiltermessagetarget">
          <z-no-results
            #noResultsTarget
            type="picklist-empty"
            iconLayer1="fa-thin fa-magnifying-glass fa-stack-1x"
            iconLayer2="fa fa-exclamation fa-flash fa-stack-2x"
            parentSelector=".p-picklist-target .p-picklist-empty-message"
            title="{{ t('core.components.grid.columns.no_results.title') }}"
            description="{{ t('core.components.grid.columns.no_results.description') }}"
          ></z-no-results>
        </ng-template>
      </p-pickList>
    </div>

    <ng-template pTemplate="footer">
      <p-toolbar styleClass="dialog-toolbar mt-4">
        <div class="p-toolbar-group-left">
          <p-button
            icon="fad fa-undo-alt"
            label="{{ t('core.components.grid.columns.reset') }}"
            styleClass="p-button-secondary p-button-outlined ml-2"
            (click)="reset()"
          ></p-button>
        </div>
        <div class="p-toolbar-group-right">
          <p-button
            icon="fad fa-check"
            label="{{ t('core.components.grid.columns.save_changes') }}"
            styleClass="p-button-primary"
            (click)="apply()"
          ></p-button>
          <p-button
            (click)="close()"
            label="{{ t('core.components.grid.columns.cancel') }}"
            styleClass="p-button-secondary ml-2"
          ></p-button>
        </div>
      </p-toolbar>
    </ng-template>
  </p-dialog>
</ng-container>
